export default {
  custom: () => import("/home/gerard/Work/vawarelabs/asufin/asufin-app-v2/layouts/custom.vue").then(m => m.default || m),
  default: () => import("/home/gerard/Work/vawarelabs/asufin/asufin-app-v2/layouts/default.vue").then(m => m.default || m)
}